<script>
    import { images } from './imageData.js';
	import Slide from './Slide.svelte';
    import Thumbnail from './Thumbnail.svelte';
    import Caption from './Caption.svelte';

	let imageShowIndex = 0;
	$: console.log(imageShowIndex);
    $: image = images[imageShowIndex];

    const prevSlide = () => {
        if (imageShowIndex === 0) {
            imageShowIndex = images.length-1;
        } else {
            imageShowIndex -= 1;
        }
    }

    const nextSlide = () => {
        if (imageShowIndex === images.length-1) {
            imageShowIndex = 0;
        } else {
            imageShowIndex += 1;
        }
    }

    const goToSlide = (number) => imageShowIndex = number;
</script>

<style>
    * {
        box-sizing: border-box;
	    font-family: 'Josefin Sans', sans-serif;
    }
	

    main {
        width: 70vw;
        display: flex;
        flex-direction: column;
        margin: 10% auto;
        background-color: #222;
        box-shadow: 0 0 10px black;
        max-width: 700px;
    }	
	
    /* Position the image container (needed to position the left and right arrows) */
    .container {
    position: relative;
    }

    .thumbnails-row {
        width: 100%;
        display: flex;
        align-self: flex-end;
    }	
</style>

<main>
	<!-- image gallery -->
	<div class="container">
		  <Slide image={image.imgurl} 
						 altTag={image.name} 
						 slideNo={image.id+1} 
						 totalSlides={images.length} 
						 />
	</div>




	<!-- Image text -->
	<Caption caption={images[imageShowIndex].caption}
					 on:prevClick={prevSlide}
					 on:nextClick={nextSlide}/>

	<!-- Thumbnail images -->
	<div class="thumbnails-row">
			{#each images as {id, imgurl, name, attribution}}
				<Thumbnail thumbImg={imgurl} 
									 altTag={name} 
									 titleLink={attribution}
									 {id} 
									 selected={imageShowIndex === id}
									 on:click={() => goToSlide(id)} />
			{/each}
	</div>
</main>



